/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import { Button, CustomHeader, Screen, Text } from "components"
import React, { useCallback, useState } from "react"
import {
  ActivityIndicator,
  FlatList,
  Image,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native"
import { style } from "./styles"
import { useFocusEffect, useNavigation } from "@react-navigation/native"
import { TabView } from "react-native-tab-view"
import { translate } from "i18n"
import LinearGradient from "react-native-linear-gradient"
import { colors } from "colors"
import { useSessionExpired } from "utils/function"
import flash from "config/flash"
import { useStores } from "models"
import moment from "moment"
import useResponsiveWidth from "components/fitSize"
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons"

import coffeeImg from "../../../../assets/coffee_animation.gif"
import expiredImg from "../../../../assets/expired-img.png"
import claimedImg from "../../../../assets/claimed-img.png"
import { useColor } from "app/theme/getThemes"

export const RewardsScreen = () => {
  const navigation = useNavigation<any>()
  const { companyTheme } = useColor()

  // const { width } = useWindowDimensions()

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()
  const [reward, setRewards] = useState([
    {
      totalRewards: 5,
      receivedReward: 5,
      rewardTitle: "Buy 5 get 1 free coffee",
      img: coffeeImg,
      status: "active",
    },
    {
      totalRewards: 10,
      receivedReward: 5,
      rewardTitle: "Buy 10 get 2 free coffee",
      img: coffeeImg,
      status: "active",
    },
  ])
  const [isLoading, setIsLoading] = useState(false)
  const [rewardHistory, setRewardHistory] = useState([
    {
      totalRewards: 5,
      receivedReward: 5,
      rewardTitle: "Buy 5 get 1 free coffee",
      img: coffeeImg,
      status: "expired",
    },
    {
      totalRewards: 10,
      receivedReward: 5,
      rewardTitle: "Buy 5 get 1 free coffee",
      img: coffeeImg,
      status: "claimed",
    },
  ])

  const [index, setIndex] = useState(0)
  const [routes] = useState([
    { key: "first", title: "Ongoing Rewards" },
    { key: "second", title: "Expired Rewards" },
  ])

  const FirstRoute = () => <Content data={reward} type="ongoing" />

  const SecondRoute = () => <Content data={rewardHistory} type="history" />

  const Content = (props) => {
    const { data, type } = props
    const isHistory = type === "history"
    return (
      <FlatList
        contentContainerStyle={style.flatListContainer}
        data={data}
        showsVerticalScrollIndicator={false}
        ListEmptyComponent={() => {
          return (
            <View style={style.emptyContainer}>
              {isLoading ? (
                <ActivityIndicator size="large" color={companyTheme.first} />
              ) : (
                <>
                  <Image
                    source={require("../../../../assets/empty-icon.png")}
                    style={{ width: 100, height: 100, resizeMode: "contain" }}
                  />
                  <Text style={style.emptyTitle}>{translate("rewardScreen.noVoucher")}</Text>
                </>
              )}
            </View>
          )
        }}
        ListFooterComponent={() => {
          return (
            <>
              {!isHistory && (
                <View style={{ alignItems: "center", marginTop: 20 }}>
                  <Text style={style.voucherDescription}>
                    {translate("rewardScreen.cannotFindVoucher")}
                  </Text>
                  <Text style={style.voucherDescription}>
                    {translate("rewardScreen.try")}{" "}
                    <Text
                      onPress={() => navigation.push("reward", { routeFrom: "history" })}
                      style={{ color: companyTheme.first }}
                    >
                      {translate("rewardScreen.searchHistory")}
                    </Text>
                  </Text>
                </View>
              )}
            </>
          )
        }}
        renderItem={({ item }) => {
          return (
            <View>
              <TouchableOpacity
                onPress={() => navigation.navigate("rewardDetail", { item })}
                style={{
                  opacity: (item.status === "expired" && 0.5) || (item.status === "claimed" && 0.5),
                }}
              >
                <LinearGradient
                  style={[style.tierContentContainer, { paddingRight: 0 }]}
                  colors={[companyTheme.first, companyTheme.second]}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 0 }}
                >
                  <View style={[style.row, { display: "flex", justifyContent: "space-around" }]}>
                    <View style={[style.ml20, { width: "70%" }]}>
                      <Text style={style.tierSpendText}>{item?.rewardTitle}</Text>
                      <View style={{ flexDirection: "row", flexWrap: "wrap", marginVertical: 10 }}>
                        {Array.from({ length: item.totalRewards })
                          .reduce((rows: any, _, index) => {
                            if (index % 5 === 0) rows?.push([])
                            rows[rows?.length - 1].push(index)
                            return rows
                          }, [])
                          .map((row, rowIndex) => (
                            <View key={rowIndex} style={{ flexDirection: "row", marginBottom: 10 }}>
                              {row.map((index) => (
                                <View
                                  key={index}
                                  style={{
                                    backgroundColor: "#D3D3D3",
                                    width: 30,
                                    height: 30,
                                    marginRight: 10,
                                    marginBottom: 10, // Add margin bottom for spacing between rows
                                    borderRadius: 15, // 50% of width/height for a perfect circle
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderWidth: 1,
                                    borderColor: index < item.receivedReward ? "#FFD700" : "black",
                                    borderStyle: "dashed",
                                    position: "relative", // For positioning sparkle icons
                                  }}
                                >
                                  {index < item.receivedReward ? (
                                    <LinearGradient
                                      colors={["#FFFACD", "#FFD700", "#FFC107"]}
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        borderRadius: 15,
                                      }}
                                    />
                                  ) : (
                                    <View
                                      style={{
                                        backgroundColor: "#fefef4",
                                        position: "absolute",
                                        borderRadius: 15,
                                      }}
                                    />
                                  )}
                                  <Text
                                    style={[
                                      style.tierSpendText,
                                      { color: "#000", zIndex: 998, marginTop: 0 },
                                    ]}
                                  >
                                    {index + 1}
                                  </Text>
                                  {index < item.receivedReward && (
                                    <>
                                      <MaterialCommunityIcons
                                        name="star-four-points"
                                        size={8}
                                        color="#FFFFE0"
                                        style={{ position: "absolute", top: 3, left: 3 }}
                                      />
                                      <MaterialCommunityIcons
                                        name="star-four-points"
                                        size={6}
                                        color="#FFFACD"
                                        style={{ position: "absolute", bottom: 5, right: 5 }}
                                      />
                                    </>
                                  )}
                                </View>
                              ))}
                            </View>
                          ))}
                      </View>
                      <Text style={[style.tierSpendText, { flex: 1 }]}>
                        You have collected{" "}
                        <Text style={{ color: "#FFC107" }}>
                          ( {item?.receivedReward}/{item?.totalRewards} )
                        </Text>{" "}
                        stamps
                      </Text>
                      {item?.receivedReward === item?.totalRewards ? (
                        <Button
                          style={[
                            style.mt10,
                            {
                              paddingTop: "3%",
                              backgroundColor: "white",
                              color: "red",
                            },
                          ]}
                          title="Redeem"
                        />
                      ) : null}
                    </View>

                    <View style={{ width: "20%" }}>
                      <Image
                        source={{
                          uri: coffeeImg,
                        }}
                        resizeMode="cover"
                        style={{ width: 70, height: 70, alignSelf: "flex-end", marginLeft: 20 }}
                      />
                    </View>
                  </View>
                </LinearGradient>
              </TouchableOpacity>
              {item.status !== "active" && (
                <TouchableOpacity style={{ position: "absolute", right: 0, bottom: 10 }}>
                  <Image
                    source={{
                      uri: item.status === "expired" ? expiredImg : claimedImg,
                    }}
                    style={{ width: 120, height: 80, resizeMode: "contain" }}
                  />
                </TouchableOpacity>
              )}
            </View>
          )
        }}
      />
    )
  }

  return (
    <>
      <CustomHeader headerTitle={translate("rewardScreen.title")} />

      <Screen>
        <View style={style.container}>
          <TabView
            swipeEnabled={false}
            animationEnabled={false}
            lazy
            renderTabBar={(props) => (
              <LinearGradient
                style={[style.linearGradient, { height: 60 }]}
                colors={[companyTheme.first, companyTheme.second]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
              >
                <TouchableOpacity style={style.headerTabBarContainer}>
                  {props.navigationState.routes.map((route, i) => {
                    return (
                      <TouchableOpacity
                        key={i}
                        onPress={() => setIndex(i)}
                        style={[style.tabBar, index === i && style.selectedTabBar]}
                      >
                        <Text
                          style={
                            index === i
                              ? { color: companyTheme.first, fontWeight: "bold" }
                              : { color: colors.white }
                          }
                        >
                          {route.title}
                        </Text>
                      </TouchableOpacity>
                    )
                  })}
                </TouchableOpacity>
              </LinearGradient>
            )}
            navigationState={{ index, routes }}
            renderScene={({ route }) => {
              switch (route.key) {
                case "first":
                  return FirstRoute()
                default:
                  return SecondRoute()
              }
            }}
            onIndexChange={setIndex}
            initialLayout={{ width }}
          />
        </View>
      </Screen>
    </>
  )
}
